(function () {
  const ROW_TOLERANCE_PX = 12;

  function renumberMarkersByLayout(root) {
    const container =
      root && root.querySelector
        ? root.closest(".product-markers") || root
        : null;
    if (!container || !container.querySelector) {
      return;
    }
    const box = container.querySelector(".product-markers__img-box");
    if (!box) {
      return;
    }
    const markers = Array.from(
      box.querySelectorAll(
        ":scope > .product-markers__marker.js-product-markers__item"
      )
    );
    if (!markers.length) {
      return;
    }
    markers.sort(function (a, b) {
      const ra = a.getBoundingClientRect();
      const rb = b.getBoundingClientRect();
      const ya = ra.top + ra.height * 0.5;
      const yb = rb.top + rb.height * 0.5;
      if (Math.abs(ya - yb) > ROW_TOLERANCE_PX) {
        return ya - yb;
      }
      const xa = ra.left + ra.width * 0.5;
      const xb = rb.left + rb.width * 0.5;
      return xa - xb;
    });
    markers.forEach(function (marker, index) {
      const count = marker.querySelector(".product-markers__count");
      if (count) {
        count.textContent = String(index + 1);
      }
      marker.classList.toggle("active", index === 0);
    });
  }

  function renumberAllInDocument() {
    document.querySelectorAll(".product-markers").forEach(renumberMarkersByLayout);
  }

  function scheduleRenumber(root) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root) {
          renumberMarkersByLayout(root);
        } else {
          renumberAllInDocument();
        }
      });
    });
  }

  function observeStageReady(scope) {
    if (!scope || scope.dataset.markerNumbersObserved === "true") {
      return;
    }
    scope.dataset.markerNumbersObserved = "true";
    if (
      !scope.querySelector(".product-markers__stage-loader") ||
      scope.classList.contains("product-markers__img--stage-ready")
    ) {
      scheduleRenumber(scope);
    }
    var observer = new MutationObserver(function () {
      if (scope.classList.contains("product-markers__img--stage-ready")) {
        scheduleRenumber(scope);
      }
    });
    observer.observe(scope, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function initMarkerNumbers() {
    document
      .querySelectorAll(".product-markers__img")
      .forEach(observeStageReady);
    scheduleRenumber();
  }

  const productMarkers = () =>
    $(document).ready(function () {
      $(".js-product-markers__item").click(function () {
        const $scope = $(this).closest(".product-markers__img");
        $scope.find(".product-markers__img-box").css({
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
        });

        $scope
          .find(".product-markers-for-mobile .js-product-markers__item-inner")
          .each(function () {
            $(this).css({ display: "none" });
          });

        $scope
          .find(
            `.product-markers-for-mobile .js-product-markers__item-inner[data-index='${$(this).data(
              "index"
            )}']`
          )
          .css({ display: "block" });
      });
      $(".product-markers-section").each(function () {
        $(this)
          .find(".product-markers__marker")
          .hover(() => {
            $(this).find(".product-markers__marker").removeClass("active");
          });
      });
    });

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(renumberAllInDocument, 150);
  });

  document.addEventListener("DOMContentLoaded", function () {
    productMarkers();
    initMarkerNumbers();
    document.addEventListener("shopify:section:load", function (event) {
      productMarkers();
      if (event.target) {
        event.target
          .querySelectorAll(".product-markers__img")
          .forEach(function (scope) {
            delete scope.dataset.markerNumbersObserved;
            observeStageReady(scope);
          });
        scheduleRenumber(event.target);
      }
    });
  });

  window.addEventListener("load", function () {
    scheduleRenumber();
  });
})();
